<template>
    <div>
        <div class="relative inline-block text-left">
            <div class="">
                <span class="rounded-md shadow-sm">
                    <button
                        @click="open = !open"
                        type="button"
                        class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white dark:bg-gray-700 dark:text-gray-300 dark:hover:text-gray-100 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                        id="options-menu"
                        aria-haspopup="true"
                        aria-expanded="true"
                    >
                        {{ dropdownText }}
                        <svg
                            class="-mr-1 ml-2 h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clip-rule="evenodd"
                            />
                        </svg>
                    </button>
                </span>
            </div>
            <transition name="dropdown">
                <div
                    v-show="open"
                    class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg"
                >
                    <div class="rounded-md bg-white dark:bg-gray-700 ring-1 ring-black ring-opacity-5">
                        <div
                            class="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                        >
                            <a
                                @click.prevent="() => toggleGraphs('lighthouse')"
                                href="#"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 dark:text-gray-300 dark:hover:text-gray-100 dark:hover:bg-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 dark:focus:bg-gray-600 focus:text-gray-900 dark:focus:text-gray-50"
                                role="menuitem"
                            >
                                Lighthouse Graph
                            </a>
                            <a
                                @click.prevent="() => toggleGraphs('webVitals')"
                                href="#"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 dark:text-gray-300 dark:hover:text-gray-100 dark:hover:bg-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 dark:focus:bg-gray-600 focus:text-gray-900 dark:focus:text-gray-50"
                                role="menuitem"
                            >
                                Web Vitals Graph
                            </a>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div class="mt-2" v-if="showLighthouseGraph">
            <seo-test-results-lighthouse-graph
                :records="records"
            >
            </seo-test-results-lighthouse-graph>
        </div>

        <div class="mt-2" v-if="showWebVitalsGraph">
            <seo-test-results-graph
                :records="records"
            >
            </seo-test-results-graph>
        </div>

    </div>
</template>
<script>
export default {
    name: "SeoViewGraphs",
    props: {
        records: {
            type: Array
        }
    },
    data(){
        return {
            open: false,
            dropdownText: "Lighthouse Graph",
            showLighthouseGraph: true,
            showWebVitalsGraph: false,
        }
    },
    methods: {
        toggleGraphs: function(toShow){
            if(toShow === "lighthouse"){
                this.dropdownText = "Lighthouse Graph";
                this.showLighthouseGraph = true;
                this.showWebVitalsGraph = false;
            }else{
                this.dropdownText = "Web Vitals Graph";
                this.showLighthouseGraph = false;
                this.showWebVitalsGraph = true;
            }
            this.open = false;
        }
    }
}
</script>
